export default "__VITE_ASSET__26092b77__"